"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Report_1 = __importDefault(require("./Report"));
class Provider {
    constructor(data) {
        this.data = data;
        this._reports = [];
        this._historicalReports = [];
        if (this.data.report1) {
            this._reports.push(new Report_1.default(this.data.report1));
        }
        if (this.data.report2) {
            this._reports.push(new Report_1.default(this.data.report2));
        }
        if (this.data.historicalReports) {
            this.loadHistoricalReports(this.data.historicalReports);
        }
    }
    get id() {
        return this.data.id;
    }
    get address() {
        return this.data.address;
    }
    get active() {
        return !this.data.purged;
    }
    get reports() {
        return this._reports;
    }
    get activeReports() {
        return this._reports.filter((r) => !r.purged);
    }
    get historicalReports() {
        return this._historicalReports.filter((r) => !r.purged);
    }
    loadHistoricalReports(reports) {
        for (const report of reports) {
            this._historicalReports.push(new Report_1.default(report));
        }
    }
}
exports.default = Provider;
//# sourceMappingURL=Provider.js.map